import { render, staticRenderFns } from "./PowerList.vue?vue&type=template&id=56a50a58&scoped=true&"
import script from "./PowerList.vue?vue&type=script&lang=js&"
export * from "./PowerList.vue?vue&type=script&lang=js&"
import style0 from "./PowerList.vue?vue&type=style&index=0&id=56a50a58&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a50a58",
  null
  
)

export default component.exports